import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PartHeaderComponent } from '../part-header/part-header.component';

@Component({
    selector: 'app-part-group',
    imports: [
        PartHeaderComponent
    ],
    templateUrl: './part-group.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './part-group.component.scss'
})
export class PartGroupComponent {

}
